// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"d659a63a","58":"cb97ca66","61":"c28ac2f7","130":"3e1b9039","292":"e3f89228","310":"ecd3c2b9","486":"7a062621","490":"d1345b31","544":"da5b0f65","570":"6a5b325d","813":"ba6cc5ab","841":"bbf43c0e","957":"95c59c68"}[chunkId] + ".chunk.js";
};